import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getMergedConversation = (conversationId, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_MERGED_CONVERSATION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/cs/conversation/${conversationId}/audio/merge`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_MERGED_CONVERSATION_DONE',
              payload: {
                response: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_MERGED_CONVERSATION_FAILED',
              payload: `getting merged conversation failed`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_MERGED_CONVERSATION_FAILED',
            payload: `getting merged conversation failed`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_MERGED_CONVERSATION_FAILED',
        payload: `getting merged conversation failed`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default getMergedConversation;
